import React from 'react';
import { NavLink } from 'react-router-dom';
import cl from './Cart.module.css';

const Cart = (props) => {
  const { cartItems, onAdd, onRemove } = props;

  const subTotalPrice = cartItems.reduce((a, c) => a + c.oldPrice * c.qty, 0);
  const totalPrice = cartItems.reduce(
    (a, c) => a + ((c.oldPrice * (100 - c.discount)) / 100) * c.qty,
    0
  );
  const discountPrice = subTotalPrice - totalPrice;
  return (
    <section className={cl.main_cart}>
      <h2 className={cl.header}>Elementi nel Carrello</h2>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'center',
        }}
      >
        {cartItems.length === 0 && (
          <div className={cl.header_empty}>Carrello Vuoto</div>
        )}
        {cartItems.map((item, i) => (
          <div key={i} className={cl.row}>
            <div className={cl.row_img_container}>
              <img src={item.images ? item.images[0] : ''} alt="" />
            </div>
            <div className={cl.name}>{item.name}</div>
            <div className={cl.buttons}>
              <button onClick={() => onAdd(item)} className={cl.add}>
                Aggiungere
              </button>
              <button onClick={() => onRemove(item)} className={cl.remove}>
                Cancellare
              </button>
            </div>
            <div className={cl.amount}>
              {item.qty} unità x {item.currency}
              {((item.oldPrice * (100 - item.discount)) / 100).toFixed(2)}
            </div>
          </div>
        ))}
      </div>
      {cartItems.length !== 0 && (
        <>
          <hr></hr>
          <div>
            <div className={cl.price}>
              <div>Subtotale</div>
              <div>
                {cartItems[0].currency}
                {subTotalPrice.toFixed(2)}
              </div>
            </div>
            <div className={cl.price}>
              <div>Sconto</div>
              <div>
                -{cartItems[0].currency}
                {discountPrice.toFixed(2)}
              </div>
            </div>
            <div className={cl.price_total}>
              <div>Prezzo Totale</div>
              <div>
                {cartItems[0].currency}
                {totalPrice.toFixed(2)}
              </div>
            </div>
          </div>
          <NavLink className={cl.button_checkout} to="/checkout">
            PROCEDI AL PAGAMENTO
          </NavLink>
        </>
      )}
    </section>
  );
};

export default Cart;
